var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation_box"},[_c('div',{staticClass:"operation_item"},[_c('md-button',{staticClass:"md-primary",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t("common.confirm"))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }